import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Stack, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SectionHeader = ({ icon, title, onBack }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box sx={{ mb: 2 }}>
      {onBack && (
        <Button startIcon={<ArrowBackIcon />} onClick={onBack} sx={{ mb: 1.5 }} size={isMobile ? 'small' : 'medium'}>
          Back to Overview
        </Button>
      )}
      <Stack direction="row" spacing={1.5} alignItems="center">
        {icon && <Box sx={{ color: 'primary.main', display: 'flex' }}>{icon}</Box>}
        <Typography variant="h6" fontWeight={600}>{title}</Typography>
      </Stack>
    </Box>
  );
};

SectionHeader.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func,
};

export default SectionHeader;